import DialogContent from "@mui/material/DialogContent";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Stack,
  Theme,
  Typography,
} from "@mui/material";
import { SidebarCloseIcon } from "lucide-react";
import React, { PropsWithChildren, SyntheticEvent } from "react";
export type SimpleDialogProps = PropsWithChildren<{
  actions?: React.ReactNode;
  descriptionText?: string;
  disableCloseOnClickOutside?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  onClose?: () => void;
  open: boolean;
  titleText: string;
}>;

export const SimpleDialog = ({
  actions,
  descriptionText,
  disableCloseOnClickOutside,
  maxWidth = "md",
  onClose,
  open,
  titleText,
  children,
}: SimpleDialogProps) => {
  const sx = styles();
  const handleClose = (
    event: SyntheticEvent,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (
      !disableCloseOnClickOutside ||
      (disableCloseOnClickOutside && reason !== "backdropClick")
    )
      onClose?.();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      sx={sx}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Stack gap={2} flexGrow={1}>
            <Typography variant="h4">{titleText}</Typography>
            {descriptionText && (
              <Typography variant="body1" maxWidth="92%">
                {descriptionText}
              </Typography>
            )}
          </Stack>
          {onClose && (
            <IconButton
              aria-label="close"
              className="SimpleDialog-closeButton"
              onClick={onClose}
            >
              <SidebarCloseIcon />
            </IconButton>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {!!actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

function styles() {
  return {
    "& .MuiDialog-paper": {
      display: "flex",
      flexDirection: "column",
      maxHeight: "85vh",
      overflowY: "hidden",
    },
    "& .MuiDialogTitle-root": {
      marginBottom: 0,
      paddingBottom: 4,
      paddingTop: 4,
    },
    "& .MuiDialogContent-root": {
      marginRight: 4,
      overflowY: "auto",
    },
    "& .SimpleDialog-closeButton": {
      alignSelf: "flex-start",
    },
  };
}
